import { filterLinkTree } from "@megarax/home";
import { AppLinkTree } from "@megarax/links";

import { isDocOfType } from "@megaron/docs-contracts";
import { useClientManager } from "@megaron/react-clients";

export const useMegaraxLinkTree = (): AppLinkTree[] => {
  const searchQuery = useClientManager("docs")
    .search()
    .useQuery({ docType: ["link"], limit: 10000 });

  const links = (searchQuery.data?.items ?? []).filter(isDocOfType("link"));

  return filterLinkTree(links);
};
